export default __webpack_public_path__ + "static/media/ihrem.c13c5883.webp";